import { isTouch } from './utils';

const html = document.querySelector('html');
const infoBoxEl = document.querySelector('.partial__info-box');
const infoBoxElClose = document.querySelector('.partial__info-box .close');
const infoBoxButtonEl = document.querySelector('.info-button');
const infoOverlay = document.querySelector('.info-overlay');

function init() {
  if (isTouch) {
    html.classList.add('has-touch');
  }

  bindInfoBoxEvents();
  handleTextSideBoxes();
}

function bindInfoBoxEvents() {
  infoBoxButtonEl && infoBoxButtonEl.addEventListener('click', toggleInfoBox);
  infoOverlay && infoOverlay.addEventListener('click', toggleInfoBox);
  infoBoxElClose && infoBoxElClose.addEventListener('click', toggleInfoBox);
}

function toggleInfoBox(evt) {
  evt.stopPropagation();
  evt.preventDefault();

  const isActive = infoBoxEl.classList.contains('is-active');

  if (isActive) {
    infoBoxEl.classList.remove('is-active');
    infoOverlay.classList.remove('is-active');
    document.body.classList.remove('info-box-is-active');
  } else {
    infoBoxEl.classList.add('is-active');
    infoOverlay.classList.add('is-active');
    document.body.classList.add('info-box-is-active');
  }
}

function handleTextSideBoxes() {
  const boxes = document.querySelectorAll('.text-sidebox');

  if (!boxes) {
    return false;
  }

  [].forEach.call(boxes, box => {
    if (box.classList.contains('expandable')) {
      // crop text
      const textNode = box.querySelector('p');
      const textContent = textNode.textContent;
      const croppedText = `${textContent.split('.')[0]}.`;
      textNode.textContent = croppedText;

      // add button
      const button = document.createElement('button');
      button.className = 'btn text-sidebox-button';
      button.textContent = 'Mehr';
      button.addEventListener('click', () => {
        textNode.textContent = textContent;
        box.removeChild(button);
      });

      box.appendChild(button);
    }
  });
}

// we attach the toggleInfoBox function to the global window object
// in order to be able to call it from a react component
window.toggleInfoBox = toggleInfoBox;

export default {
  init
};
